Vendd.Scripts.load(function () {

    var $wrapper = $('.x-cs-user-selector'),
        wrapper;

    if ($wrapper.length < 1)
        return;

    var formData = {
        loginName: $("input[name='loginName']", $wrapper).val() ? $("input[name='loginName']", $wrapper).val() : ""
    };

    //init validation options
    var us;
    var validationOptions = {
        loginName: {
            required: 'loginName-required',
            isEmail: 'loginName-invalid'
        }
    };

    if ($("input[name='loginName']", $wrapper).length > 0) {
        $wrapper.validationEngine(validationOptions);
        us = $wrapper.data('validationEngine');
    }

    wrapper = $wrapper.get(0);

    wrapper.loading = function (loading) {
        if (loading) {
            $('input', $(wrapper)).prop('disabled', true);
            $wrapper.addClass('x-loading');
        } else {
            $('input', $(wrapper)).prop('disabled', false);
            $wrapper.removeClass('x-loading');
        }
    };

    wrapper.onSubmitSetInterfaceUserSuccess = function (envelope) {
        wrapper.loading(false);

        var data = envelope.message.data;

        $('.js-error', $wrapper).hide();
        $('.js-success', $wrapper).hide();

        if (data) {
            $('.js-success', $wrapper).show();
            document.location = LhApp.Function.Url.removeParameters(['currency', 'country']);

        } else {
            $('.js-error', $wrapper).show();
        };
    };

    wrapper.onSubmitSetInterfaceUserFailure = function (envelope) {
        wrapper.loading(false);

        $('.js-error', $wrapper).show();
    };

    wrapper.onClearInterfaceUserSuccess = function (envelope) {
        wrapper.loading(false);

        var data = envelope.message.data;

        $('.js-error', $wrapper).hide();
        $('.js-success', $wrapper).hide();

        if (data) {
            document.location = LhApp.Function.Url.removeParameters(['currency', 'country']);
        } else {
            $('.js-error', $wrapper).show();
        };
    };

    wrapper.onClearInterfaceUserFailure = function (envelope) {
        wrapper.loading(false);

        $('.js-error', $wrapper).show();
    };

    wrapper.submit = function () {
        wrapper.loading(true);
        Vendd.MessageBus.publishAsync(wrapper, new Vendd.UserSelect.Messages.SubmitSetInterfaceUser(formData));
    };

    $wrapper.on('blur', 'input[name]:not([type="checkbox"]), textarea[name]', function (e) {
        var fieldName = $(this).attr('name');

        formData[fieldName] = $(this).val() || "";

        us.validate(fieldName);
    });

    $wrapper.on('keyup', 'input[name]:not([type="checkbox"]), textarea[name]', function (e) {

        var fieldName = $(this).attr('name');

        formData[fieldName] = $(this).val() || "";

        us.validate(fieldName);
    });

    $(".js-submit-button").on('click', function (e) {
        e.preventDefault();
        e.stopPropagation();

        formData.loginName = $('input[name="loginName"]', $wrapper).val();

        var val = us.validate();

        if (val) wrapper.submit();      
    });

    $(".js-clear-button").on('click', function () {
        wrapper.loading(true);
        Vendd.MessageBus.publishAsync(wrapper, new Vendd.UserSelect.Messages.ClearInterfaceUser(formData));
    });

    //wrapper.fields = [];
    var $preEmptiveOptions = $('*[data-input="pre-emptive-options"]');
    if ($preEmptiveOptions.length === 0)
        return;
    var $userLoginNameInput = $('*[name="loginName"]');

    var preEmptiveOptionsDef = {
        serviceUrl: LhApp.Function.Url.getServiceEndpoint('AuthService.svc/SearchUsers'),
        minChars: 2,
        maxHeight: 400,
        zIndex: 200,
        deferRequestBy: 800, //miliseconds
        noCache: false, //default is false, set to true to disable caching
        onSelect: function (suggestion) {
            formData.loginName = suggestion.value;
            $(".js-submit-button", $wrapper).trigger('click');
        }
    };
    var preEmptiveOpts = {};
    $.extend(true, preEmptiveOpts, preEmptiveOptionsDef, JSON.parse($preEmptiveOptions.val())); 

    $userLoginNameInput.autocomplete(preEmptiveOpts);

    $preEmptiveOptions.remove();
    
    Vendd.MessageBus.subscribe(Vendd.UserSelect.Messages.SubmitSetInterfaceUserSuccess, wrapper, wrapper.onSubmitSetInterfaceUserSuccess);
    Vendd.MessageBus.subscribe(Vendd.UserSelect.Messages.SubmitSetInterfaceUserFailure, wrapper, wrapper.onSubmitSetInterfaceUserFailure);
    Vendd.MessageBus.subscribe(Vendd.UserSelect.Messages.ClearInterfaceUserSuccess, wrapper, wrapper.onClearInterfaceUserSuccess);
    Vendd.MessageBus.subscribe(Vendd.UserSelect.Messages.ClearInterfaceUserFailure, wrapper, wrapper.onClearInterfaceUserFailure);
    //Vendd.MessageBus.subscribe(Vendd.UserSelect.Messages.SearchUsersSuccess, wrapper, wrapper.onSearchUsersSuccess);
    //Vendd.MessageBus.subscribe(Vendd.UserSelect.Messages.SearchUsersFailure, wrapper, wrapper.onSearchUsersFailure);
});